/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2020 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import $ from 'jquery';

import '@accessible360/accessible-slick';
//import './depage-jquery-plugins/depage-analytics';
import './depage-jquery-plugins/depage-email-antispam';
import './depage-jquery-plugins/depage-magaziner';
import './depage-jquery-plugins/depage-gallery';
import './depage-jquery-plugins/depage-player';
import './depage-jquery-plugins/depage-audio';
import { throttle } from 'lodash-es';

import CustomMap from './modules/map';

import '../sass/global.scss';

var biw = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var $sidebar;

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $("html").addClass("javascript");

            localJS.setupMagaziner();

            localJS.setup();
        },
        // }}}
        // {{{ setup
        setup: function($main) {
            if (typeof $main == 'undefined') {
                $main = $("html");
            }

            localJS.setupNavigation($main);
            localJS.setupSidebar($main);
            localJS.setupVarious($main);
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function($main) {
            // add click event for teaser
            $main.find(".teaser").on("click", function(e) {
                if (e.isTrigger != 3){
                    $("a", this)[0].click();
                }
            });

            // email antispam
            $main.find("a[href*='mailto:']").depageAntispam();

            //localJS.setupSlideshows($main);
            localJS.setupSlider($main);
            localJS.setupAudio($main);
            localJS.setupVideos($main);
            localJS.setupGallery($main);
            localJS.setupMap($main);
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function($main) {
            var $header = $("header", $main);
            //var $nav = $("nav.main");

            var setActiveNav = throttle(function() {
                //var windowHeight = $(window).height();
                var scrollTop = ( window.pageYOffset || $(window).scrollTop() );

                $header.toggleClass("on-top", scrollTop < 100);

                /*
                for (var i = 0; i < $scrollFader.length; i++) {
                    var $fader = $scrollFader.eq(i);

                    $fader.toggleClass("in-view", $fader.offset().top < scrollTop + windowHeight * 0.85);
                }
                if ($fixedHeader.length > 0) {
                    $fixedHeader.toggleClass("fixed-nav", $fixedHeaderTest.offset().top + $fixedHeaderTest.height() * 0.85 < scrollTop);
                }
                */
            }, 200);
            $(window).on("scroll", setActiveNav );
            setTimeout(setActiveNav, 300);
        },
        // }}}
        // {{{ setupMagaziner
        setupMagaziner: function() {
            var $pagecontainer = $("#pagecontainer");
            var $navLinks = $("nav.sidebar a");

            $pagecontainer.depageMagaziner("nav a.active");

            var pageController = $pagecontainer.data("depage.magaziner");

            if (pageController) {
                $pagecontainer.on("depage.magaziner.loaded", function(e, url, $page) {
                    localJS.setup($page);
                });
                $pagecontainer.on("depage.magaziner.statechangecomplete", function(e, url) {
                    var $currentLink;

                    $("nav.sidebar .active, nav.sidebar .parent-of-active").removeClass("active").removeClass("parent-of-active");

                    for (var i = 0; i < $navLinks.length; i++) {
                        var $link = $navLinks.eq(i);
                        if ($link[0].href == url) {
                            $currentLink = $link;
                        }
                    }

                    if ($currentLink) {
                        $currentLink
                            .parents("li").addClass("parent-of-active")
                            .children("a").addClass("parent-of-active");
                        $currentLink.addClass("active");
                    }
                    localJS.closeSidebar();

                    $(".gallery-overlay").remove();
                });
                $pagecontainer.on("depage.magaziner.show", function(e, url, $page) {
                    localJS.setupVarious($page);
                });
                $pagecontainer.on("depage.magaziner.hide", function(e, $page) {
                    $page.find(".video").each( function() {
                        var player = $(this).data("depage.player");

                        if (player.playing) {
                            player.pause();
                        }
                    });
                });
            }
        },
        // }}}
        // {{{ setupSlideshows
        setupSlideshows: function($main) {
            $main.find(".slideshow").depageSlideshow({
                elements: "figure, div",
                speed: 2000,
                pause: 5000
            });
        },
        // }}}
        // {{{ setupSlider
        setupSlider: function($main) {
            $main.find(".start:not(.slick-initialized)").slick({
                slide: ".logo:not(.flex-spacer)",
                rows: 0,
                initialSlide: 0,
                slidesToScroll: 1,
                infinite: false,
                slidesToShow: 1,
                swipe: false,
                draggable: false,
                variableWidth: true
            });
        },
        // }}}
        // {{{ setupAudio
        setupAudio: function($main) {
            var $songs = $main.find(".song");

            $songs.each(function() {
                var $song = $(this);

                $song.depageAudio({
                    assetPath: "lib/global/images/",
                    imageSuffix: ".svg",
                    onEnd: function() {
                    },
                    onPause: function() {
                    },
                    onPlay: function() {
                    }
                });
            });
        },
        // }}}
        // {{{ setupVideos
        setupVideos: function($main) {
            var $videos = $main.find(".video");

            $videos.each( function() {
                var $video = $(this);

                $video.depagePlayer({
                    crop: false,
                    constrain: false,
                    assetPath: "lib/global/images/",
                    onPlay: function() {
                        $video.find(".controls").show();
                    }
                });
            });
        },
        // }}}
        // {{{ setupGallery
        setupGallery: function($main) {
            $main.find(".gallery").depageGallery();
        },
        // }}}
        // {{{ setupMap
        setupMap: function($main) {
            var $maps = $main.find("#map:not(.map-initialized)");

            $maps.each(function() {
                var $mapContainer = $(this).parent();
                var locations = [];
                
                $mapContainer.find(".map-location").each(function() {
                    locations.push($(this).data("location"));
                });

                new CustomMap(this, locations);
            });
        },
        // }}}
        // {{{ setupSidebar
        setupSidebar: function($main) {
            $sidebar = $("nav.sidebar", $main);
            $sidebar.children(".burger-icon").on("click", function() {
                localJS.toggleSidebar();
            });
        },
        // }}}
        // {{{ toggleSidebar
        toggleSidebar: function() {
            if ($sidebar.hasClass("menu-open")) {
                localJS.closeSidebar();
            } else {
                localJS.openSidebar();
            }
        },
        // }}}
        // {{{ openSidebar
        openSidebar: function() {
            $sidebar.addClass("menu-open");
            $sidebar.children(".burger-icon")
                .attr("aria-expanded", "true");
            $sidebar.children(".sidebar-menu")
                .removeAttr("inert");
        },
        // }}}
        // {{{ closeSidebar
        closeSidebar: function() {
            $sidebar.removeClass("menu-open");
            $sidebar.children(".burger-icon")
                .attr("aria-expanded", "false");
            $sidebar.children(".sidebar-menu")
                .attr("inert", "inert");
        },
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(function() {
    biw.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
